/* eslint-disable import/first */
import React, { useEffect } from 'react';
import css from './index.module.scss';
import { Slices, Redux } from 'spwa-ui-library';
const { getDecimalPoints } = Slices.configSlice;
const { useSelector } = Redux;
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { FormattedMessage } from 'react-intl';

export default function ProductTilePrice({ currency, price, strikeOutPrice, discountPercentage }) {
  const [showStrike, setShowStrike] = React.useState(strikeOutPrice > price);
  const decimalPoints = useSelector(getDecimalPoints);
  useEffect(() => {
    setShowStrike(strikeOutPrice > price);
  }, [strikeOutPrice, price]);
  return (
    <div className={css.price}>
      <div className={css.cost}>
        {price === 0 ? (
          <span className={css.freePrice}>
            <FormattedMessage id="free" defaultMessage="free" />
          </span>
        ) : (
          <>
            <span>{decimalChecker(price, decimalPoints)}</span> <span>{currency}</span>
          </>
        )}
      </div>
      {showStrike && strikeOutPrice && price > 0 ? (
        <div className={css.strikeOut}>
          <span>{decimalChecker(strikeOutPrice, decimalPoints)}</span> <span>{currency}</span>
        </div>
      ) : (
        ''
      )}
      {/*discountPercentage && <div className={css.percentage}>{discountPercentage}</div>*/}
    </div>
  );
}
